import Filter from 'bad-words';
import config from "config";
import { MainMenuService } from "./mainMenu.service";
import { SignInService } from './signin.service';

export class SignUpService {
    private signUpScreen;
    private mainMenuService: MainMenuService;
    private signInService: SignInService;
    private colDays: number;

    public show(): void {
        this.signUpScreen = document.getElementById('signUp');
        this.signUpScreen.style.visibility = 'visible';

        this.mainMenuService = new MainMenuService();
        this.signInService = new SignInService();

        const btnSignInForm = document.getElementById('signIn_upLinks') as HTMLButtonElement;
        btnSignInForm.addEventListener('click', async (e) => {
            e.preventDefault();
            this.signUpScreen.style.visibility = 'hidden';

            this.signInService.show();
        });

        const guestBtn = document.getElementById('guest_upLinks') as HTMLButtonElement;
        guestBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            config.guest = true;
            this.signUpScreen.style.visibility = 'hidden';

            const login = document.getElementById('login');
            login.style.visibility = 'visible';
            const gameId = Math.random().toString(26).slice(2);
            config.gameId = `${gameId}`;
        })

        this.addListeners();
    }

    private validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    
    private validatePass(password) {
        const re = /(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/g;
        return re.test(password);
    }
    
    private validateDay(number) {
        const re = /[0-9]|\./;
        return re.test(number);
    }

    private async addListeners(): Promise<void> {        

        const signUpBtn = document.getElementById('signUp_link_btn') as HTMLButtonElement;
        signUpBtn.addEventListener('click', () => {
            this.signUpScreen.style.visibility = 'hidden';

            const signUpScreen = document.getElementById('signUp');
            signUpScreen.style.visibility = 'visible';
        })

        const firstName = document.getElementById('firstName') as HTMLInputElement;
        const eventFirstName = (e) => {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const error = document.getElementById('firstname-errors') as HTMLElement;
            if(value){
                firstName.classList.remove('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'none';
            } else {
                firstName.classList.add('form__input--empty');
                
                //@ts-ignore
                error.children[0].style.display = 'block';
            }
        }

        firstName.addEventListener('input', (e: any) => eventFirstName(e));
        firstName.addEventListener('focus', (e: any) => eventFirstName(e));

        const lastName = document.getElementById('lastName') as HTMLInputElement;
        const eventLastName = (e) => {
                let value = e.target.value;
                value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
                const error = document.getElementById('lastname-errors') as HTMLElement;
                if(value){
                    lastName.classList.remove('form__input--empty');
                    //@ts-ignore
                    error.children[0].style.display = 'none';
                } else {
                    lastName.classList.add('form__input--empty');
                    //@ts-ignore
                    error.children[0].style.display = 'block';
                }
        }

        lastName.addEventListener('input', (e: any) => eventLastName(e));
        lastName.addEventListener('focus', (e: any) => eventLastName(e));

        const email = document.getElementById('email') as HTMLInputElement;
        const eventEmail = (e) => {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const error = document.getElementById('email-erros') as HTMLElement;
            if(value){
                email.classList.remove('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'none';
            } else {
                email.classList.add('form__input--empty');
                //@ts-ignore
                error.children[0].style.display = 'block';
            }
        }

        email.addEventListener('input', (e: any) => eventEmail(e));
        email.addEventListener('focus', (e: any) => eventEmail(e));

        const password = document.getElementById('password') as HTMLInputElement;
        const eventPass = (e) => {
            let value = e.target.value.trim();
            const check = this.validatePass(value);
            
            const error = document.getElementById('password-errors') as HTMLElement;
            if(value){
                password.classList.remove('form__input--empty');
            } else {
                password.classList.add('form__input--empty');
            }

            //@ts-ignore
            if(check)error.children[0].style.display = 'none';
            //@ts-ignore
            else error.children[0].style.display = 'block';
        }

        password.addEventListener('input', (e: any) => eventPass(e));
        password.addEventListener('focus', (e: any) => eventPass(e));

        const year = document.getElementById('dateOfBirth_year') as HTMLInputElement;
        const yearError = document.getElementById('dobYear-errors') as HTMLElement;

        year.addEventListener('input', (e: any) => {
            
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const error = document.getElementById('email-errors') as HTMLElement;
            if(value){
                setDays();
                checkDay();
                year.classList.remove('form__input--empty');
                //@ts-ignore
                yearError.children[0].style.display = 'none';
            } else {
                year.classList.add('form__input--empty');
                //@ts-ignore
                yearError.children[0].style.display = 'block';
            }
        })

        const month = document.getElementById('dateOfBirth_month') as HTMLInputElement;
        const monthError = document.getElementById('dobMonth-errors') as HTMLElement;

        month.addEventListener('input', (e: any) => {
            let value = e.target.value;
            value = value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const error = document.getElementById('email-errors') as HTMLElement;
            
            if(value){
                setDays();
                month.classList.remove('form__input--empty');
                //@ts-ignore
                monthError.children[0].style.display = 'none';
            } else {
                month.classList.add('form__input--empty');
                //@ts-ignore
                monthError.children[0].style.display = 'block';
            }
        })
        
        const day = document.getElementById('dateOfBirth_day') as HTMLSelectElement;
        const dayError = document.getElementById('dobDay-errors') as HTMLElement;
        // day.addEventListener('click', () => {
        //     // const monthValue = Number(month.value);
        //     // let yearValue = Number(year.value);
            
        //     // if(monthValue && yearValue === 0) yearValue = 2008
        //     // if(monthValue && yearValue) {
        //     //     day.querySelectorAll('option').forEach((el) => el.remove());
        //     //     this.colDays = new Date(yearValue, monthValue, 0).getDate();
        //     //     for (let i = 0; i < this.colDays; i++) {
        //     //         const el = document.createElement("option");
        //     //         el.textContent = `${i + 1}`;
        //     //         el.value = `${i + 1}`;
        //     //         day.appendChild(el);
        //     //     }
        //     // }
        // })

        day.addEventListener('focus', (e: any) => {
            let value = e.target.value;

            const newVal = value.replace(/[^+\d]/g, '');
            day.value = newVal.trim();
            if(newVal){
                day.classList.remove('form__input--empty');
                //@ts-ignore
                dayError.children[0].style.display = 'none';
            } else {
                day.classList.add('form__input--empty');
                //@ts-ignore
                dayError.children[0].style.display = 'block';
            }
        })

        const setDays = () => {
            if(day.value) {
                const dayNow = day.value;
                const monthValue = Number(month.value);
                let yearValue = Number(year.value);
                
                if(monthValue && yearValue === 0) yearValue = 2008
                if(monthValue && yearValue) {
                    day.querySelectorAll('option').forEach((el) => el.remove());

                    const el = document.createElement("option");
                    el.textContent = `Day*`;
                    el.value = `${0}`;
                    day.appendChild(el);

                    this.colDays = new Date(yearValue, monthValue, 0).getDate();
                    for (let i = 0; i < this.colDays; i++) {
                        const el = document.createElement("option");
                        el.textContent = `${1 +i}`;
                        el.value = `${1 + i}`;
                        day.appendChild(el);
                    }
                }

                day.value = dayNow;
            } else {
                const monthValue = Number(month.value);
                let yearValue = Number(year.value);
                
                if(monthValue && yearValue === 0) yearValue = 2008
                
                if(monthValue && yearValue) {
                    day.querySelectorAll('option').forEach((el) => el.remove());

                    const el = document.createElement("option");
                    el.textContent = `Day*`;
                    el.value = `${0}`;
                    day.appendChild(el);

                    this.colDays = new Date(yearValue, monthValue, 0).getDate();
                    for (let i = 0; i < this.colDays; i++) {
                        const el = document.createElement("option");
                        el.textContent = `${i + 1}`;
                        el.value = `${i + 1}`;
                        day.appendChild(el);
                    }
                }
            }            
        }

        const checkDay = () => {
            if(day.value) {
                const monthValue = Number(month.value);
                const yearValue = Number(year.value);
                
                const daysMonth = new Date(yearValue, monthValue, 0).getDate();
                
                if(this.colDays !== daysMonth && monthValue === 2 && Number(day.value) === 29) {
                    day.querySelectorAll('option').forEach((el) => el.remove());
                    day.value = '';
                } 
            }
        }

        const btnPass = document.getElementById('toggle_pass');
        btnPass.addEventListener('click', () => {
            const typePass = password.getAttribute('type');
            if(typePass === 'password') password.setAttribute('type', 'text');
            else password.setAttribute('type', 'password');
        });
        
        const checkboxEmails = document.getElementById('newsletter') as HTMLInputElement;
        const checkbox = document.getElementById('signUpTerms') as HTMLInputElement;
        const errorUpTerms = document.getElementById('signupterms-errors') as HTMLElement;
        checkbox.addEventListener('click', () => {
            if(checkbox.checked){
                //@ts-ignore
                errorUpTerms.children[0].style.display = 'none';
            } else {
                // firstName.classList.add('form__input--empty');
                //@ts-ignore
                errorUpTerms.children[0].style.display = 'block';
            }
        });

        const btn = document.getElementById('signUp_btn');
        btn.addEventListener('click', async (e: any) => {
            e.preventDefault();
            
            const check = this.checkForm();
            const token = await this.loadCaptcha();

            if(check) {
                if(config.debugMode) {
                    const testData = {
                        id: "25eca36c-4c35-4095-8d8c-ce17b4550dfe",
                        token: "/ZLTG2qVzUCmVRUTNLNa9Q==",
                        message: "",
                        status: "200",
                        redirectUrl: "/match-the-ink-game"
                    }
    
                    config.token = testData.token;
                    config.playerId = testData.id;
    
                    this.signUpScreen.style.visibility = 'hidden';
                    const startScreen = document.getElementById('login');
                    startScreen.style.visibility = 'visible';
                } else {
                    const raw = JSON.stringify({
                        "firstName": firstName.value,
                        "lastName": lastName.value,
                        "username": email.value,
                        "password": password.value,
                        "dateOfBirth_month": month.value,
                        "dateOfBirth_date": day.value,
                        "dateOfBirth_year": year.value,
                        "signUpTerms": Number(checkbox.checked),
                        "newsletter": Number(checkboxEmails.checked),
                        "recaptchaToken": token,
                        "redirectUrl": "/match-the-ink-game"
                    });
    
                    const requestOptions = {
                        method: 'POST',
                        body: raw,
                        redirect: 'follow',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                        }
                    };
                    // @ts-ignore
                    fetch(`${config.path}/match-game/register`, requestOptions)
                        .then(response => response.json())
                        .then((result: any) => {
                            // console.log(result);
                            const errorSignUp = document.getElementById('sign_up_error') as HTMLElement;
                            if(result.message === "recaptcha-mandatory") {
                                errorSignUp.style.display = 'block';
                                errorSignUp.textContent = 'Recaptcha wrong';
                            } else if(result.status === '410' || result.id === null) {
                                errorSignUp.style.display = 'block';
                                errorSignUp.textContent = 'Something Went Wrong';
                            } else {config.token = result.token;
                            config.playerId = result.id;

                            sessionStorage.setItem('token', JSON.stringify({
                                token: result.token,
                                id: result.id
                            }));
                            config.guest = false;
                            this.signUpScreen.style.visibility = 'hidden';
                            const startScreen = document.getElementById('login');
                            startScreen.style.visibility = 'visible';}
                        })
                        .catch(error => {
                            console.log('error', error);                        
                        });
                }
            }
        })
    }

    private checkForm() {
        let valid = true;

        const firstName = document.getElementById('firstName') as HTMLInputElement;
        const valEmail = firstName.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const errorName = document.getElementById('firstname-errors') as HTMLElement;
        valid = valEmail && valid;
        if(valEmail){
            firstName.classList.remove('form__input--empty');
            //@ts-ignore
            errorName.children[0].style.display = 'none';
        } else {
            firstName.classList.add('form__input--empty');
            //@ts-ignore
            errorName.children[0].style.display = 'block';
        }
        
        const lastName = document.getElementById('lastName') as HTMLInputElement;
        const valLastName = lastName.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const errorLastName = document.getElementById('lastname-errors') as HTMLElement;
        valid = valLastName && valid;
        if(valEmail){
            lastName.classList.remove('form__input--empty');
            //@ts-ignore
            errorLastName.children[0].style.display = 'none';
        } else {
            lastName.classList.add('form__input--empty');
            //@ts-ignore
            errorLastName.children[0].style.display = 'block';
        }

        const email = document.getElementById('email') as HTMLInputElement;
        // const valEmail = email.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const check = this.validateEmail(email.value);
        const error = document.getElementById('email-erros') as HTMLElement;
        
        valid = check && valid;
        if(check){
            email.classList.remove('form__input--empty');
            //@ts-ignore
            error.children[0].style.display = 'none';
        } else {
            email.classList.add('form__input--empty');
            //@ts-ignore
            error.children[0].style.display = 'block';
        }

        const password = document.getElementById('password') as HTMLInputElement;
        const valPass = password.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
        const errorPass = document.getElementById('password-errors') as HTMLElement;
        valid = !!valPass && valid; 
        if(valPass){
            password.classList.remove('form__input--empty');
            //@ts-ignore
            errorPass.children[0].style.display = 'none';
        } else {
            password.classList.add('form__input--empty');
            //@ts-ignore
            errorPass.children[0].style.display = 'block';
        }

        const signUpTerms = document.getElementById('signUpTerms') as HTMLInputElement;
        const errorUpTerms = document.getElementById('signupterms-errors') as HTMLElement;

        valid = signUpTerms.checked && valid;
        if(signUpTerms.checked){
            // firstName.classList.remove('form__input--empty');
            //@ts-ignore
            errorUpTerms.children[0].style.display = 'none';
        } else {
            // firstName.classList.add('form__input--empty');
            //@ts-ignore
            errorUpTerms.children[0].style.display = 'block';
        }

        const year = document.getElementById('dateOfBirth_year') as HTMLInputElement;
        const yearError = document.getElementById('dobYear-errors') as HTMLElement;
        // year.addEventListener('input', (e: any) => {
            // let value = e.target.value;
            const valueYear = year.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            if(valueYear){
                year.classList.remove('form__input--empty');
                //@ts-ignore
                yearError.children[0].style.display = 'none';
            } else {
                year.classList.add('form__input--empty');
                //@ts-ignore
                yearError.children[0].style.display = 'block';
            }
        // })

        const month = document.getElementById('dateOfBirth_month') as HTMLInputElement;
        const monthError = document.getElementById('dobMonth-errors') as HTMLElement;
        // month.addEventListener('input', (e: any) => {
            // let valueMonth = e.target.value;
        const valueMonth = month.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            if(valueMonth){
                month.classList.remove('form__input--empty');
                //@ts-ignore
                monthError.children[0].style.display = 'none';
            } else {
                month.classList.add('form__input--empty');
                //@ts-ignore
                monthError.children[0].style.display = 'block';
            }
        // })
        
        const day = document.getElementById('dateOfBirth_day') as HTMLInputElement;
        // day.addEventListener('input', (e: any) => {
        const valueDay = day.value.replace(/[^A-Za-z0-9А-Яа-я]/ig, '');
            const dayError = document.getElementById('dobDay-errors') as HTMLElement;
            
            if(valueDay){
                day.classList.remove('form__input--empty');
                //@ts-ignore
                dayError.children[0].style.display = 'none';
            } else {
                day.classList.add('form__input--empty');
                //@ts-ignore
                dayError.children[0].style.display = 'block';
            }
        // })



        // //@ts-ignore
        // grecaptcha.ready(function() {
        //     //@ts-ignore
        //     grecaptcha.execute('6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7', {action: 'submit'}).then(function(token) {
        //         // console.log('token ::', token);                
        //         // Add your logic to submit to your backend server here.
        //     });
        // });

        return valid;
    }

    private async loadCaptcha() {
        const head = document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://www.google.com/recaptcha/api.js?render=6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7';
		head.appendChild(script);

        const token = await new Promise( resolve => {
            script.onload = async() => {
                //@ts-ignore
                grecaptcha.ready(function() {
                    //@ts-ignore
                    grecaptcha.execute('6LdZiegUAAAAAL8YDN40G7GGJR25niJz__YVxQJ7', {action: 'submit'}).then(function(token) {
                        // console.log('token ::', token);
                        resolve(token);
                        // Add your logic to submit to your backend server here.
                    });
                });
            }
        });

        return token;
    }
}